var _circle, _path, _path2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70%",
    height: "70%",
    viewBox: "0 0 90 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.9766,
    cy: 44.5,
    r: 43,
    fill: "#FFE0A7",
    stroke: "#FFC04B",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.9766 52C78.9766 71.0344 63.3261 86.5 43.9766 86.5C24.627 86.5 8.97656 71.0344 8.97656 52C8.97656 32.9656 24.627 17.5 43.9766 17.5C63.3261 17.5 78.9766 32.9656 78.9766 52Z",
    fill: "#FFE0A7",
    stroke: "#FFC04B",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9766 61C70.9766 75.0574 59.362 86.5 44.9766 86.5C30.5911 86.5 18.9766 75.0574 18.9766 61C18.9766 46.9426 30.5911 35.5 44.9766 35.5C59.362 35.5 70.9766 46.9426 70.9766 61Z",
    fill: "#FFE0A7",
    stroke: "#FFC04B",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.9766,
    cy: 70.5,
    r: 16,
    fill: "#FFE0A7",
    stroke: "#FFC04B",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcho);
export default __webpack_public_path__ + "static/media/echo.1ef9a7cf2b58465c77a43a8b99b98afa.svg";
export { ForwardRef as ReactComponent };